import React,{ useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import FavoriteIcon from '@mui/icons-material/Favorite';

export default function NotificationFeed({titleHead}){
	
	let navigate = useNavigate();
	
	useEffect(() => {
		let authToken = sessionStorage.getItem("Auth Token");
		
		if(authToken){
			navigate('/notification')
		}
		
		if(!authToken){
			navigate('/')
		}
	}, [])
	
	return(
		<>
			<section style={{display: "flex", gap: "0.5rem"}}>
			<FavoriteIcon sx={{ width: 50, height: 50, color: "#ec407a", }}/>
				<div>
					<Avatar className="post-user-img" alt="Remy Sharp" src="https://source.unsplash.com/random/girl" onClick={() => {navigate('/profile')}} sx={{ width: 50, height: 50 }} />
					<p><strong>Infi</strong> Liked your meow and commented on it "Get going"</p>
				</div>
			</section>
			<hr />
		</>
	);
}